import React, { useEffect } from "react";
import TitleBar from "../components/TitleBar/TitleBar";
import MenuBar from "../components/dashboard/MenuBar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { Outlet, useLocation } from "react-router-dom";
import "../Styles/DashboardStyles.css";
import LoaderComponent from "../components/StyledComp/Loader";

const DashBoard: React.FC = () => {
  const search = useLocation().search;
  const dispatch = useDispatch();
  console.log(search);
  // const popUpType = new URLSearchParams(search).get("popUpType");
  // console.log(popUpType);
  // switch (popUpType) {
  //   case "facebookPage":
  //     console.log(" show facebookPage");
  //     dispatch(faceBookPageModalOpen(true));
  //     break;
  //   default:
  //     dispatch(faceBookPageModalOpen(false));
  //     break;
  // }

  // const currentScreen = useSelector(
  //   (state: RootState) => state.screen.currentScreen
  // );
  const isFbTypeModalOpen = useSelector(
    (state: RootState) => state.modal.isFaceBookTypeModal
  );
  const isFbPageModalOpen = useSelector(
    (state: RootState) => state.modal.isFaceBookPageModalOpen
  );
  // console.log("currentScreen in  home", currentScreen);

  useEffect(() => {
    console.log("useEffect in Dashboard");
  });
  return (
    <>
      {/* </><div className="dashboard"> */}
      <LoaderComponent />
      <TitleBar />
      <div className="dashboard-body">
        <MenuBar />
        {/* <CreateMemberPage /> */}
        {/* <MemberHomePage /> */}

        <Outlet />
      </div>
    </>
    // </div>
  );
};

export default DashBoard;
